/**
 * @fileoverview Notification preferences query hook.
 * @description Wraps GET /notifications/preferences in a TanStack query for the profile's
 * Notifications tab.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { getNotificationPreferences } from '@/features/notifications/services/notification-preferences.service'

export const NOTIFICATION_PREFERENCES_QUERY_KEY = ['notifications', 'preferences'] as const

/**
 * @description Fetches the signed-in user's notification preferences.
 * @returns {ReturnType<typeof useQuery>} The query object (data, isPending, error, refetch, ...).
 */
export function useNotificationPreferences() {
  return useQuery({
    queryKey: NOTIFICATION_PREFERENCES_QUERY_KEY,
    queryFn: getNotificationPreferences,
  })
}
